module.exports = __webpack_public_path__ + "img/about.ab9dab96.png";